import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Helpers
import { isRdStationTrackedPath, loadRdStationScript } from 'helpers/rdStation';

/**
 * Carrega o script de monitoramento da RD Station apenas nas rotas do
 * e-commerce (venda de passagens) e apenas quando REACT_APP_RD_STATION_LOADER_URL
 * estiver definida no ambiente (hoje: CatSul). Não renderiza nada.
 */
const RdStationTracking: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isRdStationTrackedPath(pathname)) loadRdStationScript();
  }, [pathname]);

  return null;
};

export default RdStationTracking;
